import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';

@Injectable({
  providedIn: 'root'
})

export class EvaluatorAuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.authService.getIsEvaluator()) {
      return true;
    } else {
      this.router.navigateByUrl('access-denied');
      return false;
    }
  }
}
